<div class="favorites-star-container">
  <mat-spinner *ngIf="buttonDisabled" diameter="21" class="spacing--margin-right"></mat-spinner>
  <mat-icon
    *ngIf="!buttonDisabled"
    color="accent"
    class="favorites-star-container__favorites-star"
    (click)="toggleFavorite()"
    [matTooltip]="
      (isFavorite ? 'app.favorites.remove-favorite' : isFavoritePage ? 'app.favorites.add-back-favorite' : 'app.favorites.add-favorite') | translate
    "
    matTooltipPosition="above"
    >{{ isFavorite ? 'star' : 'star_outline' }}
  </mat-icon>
</div>
